import { useEffect, useState } from "react";

export const useMultipleQuery = (queries) => {
  const [state, setState] = useState({
    data: Object.fromEntries(Object.keys(queries).map((k) => [k, null])),
    isLoading: false,
    isError: false,
    isSuccess: false,
    errors: [],
  });

  useEffect(
    () => {
      setState({
        data: Object.fromEntries(
          Object.keys(queries).map((k) => [k, queries[k].data]),
        ),
        refetch: Object.fromEntries(
          Object.keys(queries).map((k) => [`${k}Refetch`, queries[k].refetch]),
        ),
        isLoading: Object.values(queries)
          .map((q) => q.isLoading)
          .reduce((a, v) => a || v, false),
        isError: Object.values(queries)
          .map((q) => q.isError)
          .reduce((a, v) => a || v, false),
        errors: Object.fromEntries(
          Object.keys(queries).map((k) => [k, queries[k].error]),
        ),
        isSuccess: Object.values(queries)
          .map((q) => q.isSuccess)
          .reduce((a, v) => a && v, true),
      });
    },
    Object.values(queries).map((q) => q.isFetching),
  );

  return state;
};
